import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SkillPathEntryFieldsFragment = { __typename?: 'GuideLevel', id: string, name: string, code?: string | null, guideId: string, subjectId: string, onStudentsSkillPaths?: boolean | null, skillPathMinDueDate?: any | null, skillPathMaxDueDate?: any | null, skillPathMinStartDate?: any | null, skillPathMaxStartDate?: any | null, skillPathStudentCount: number, skillPathCompletedStudentCount: number, parent?: { __typename?: 'GuideLevel', id: string, parent?: { __typename?: 'GuideLevel', id: string } | null } | null };

export type SkillPathEntriesQueryVariables = Types.Exact<{
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  status?: Types.InputMaybe<Types.SkillPathStatus>;
  isScheduled: Types.Scalars['Boolean']['input'];
  filter?: Types.InputMaybe<Types.GuideLevelFilterInput>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.GuideLevelSortInput>> | Types.InputMaybe<Types.GuideLevelSortInput>>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SkillPathEntriesQuery = { __typename?: 'RootQueryType', skillPathEntries?: { __typename?: 'PageOfGuideLevel', hasNextPage: boolean, results?: Array<{ __typename?: 'GuideLevel', id: string, name: string, code?: string | null, guideId: string, subjectId: string, onStudentsSkillPaths?: boolean | null, skillPathMinDueDate?: any | null, skillPathMaxDueDate?: any | null, skillPathMinStartDate?: any | null, skillPathMaxStartDate?: any | null, skillPathStudentCount: number, skillPathCompletedStudentCount: number, parent?: { __typename?: 'GuideLevel', id: string, parent?: { __typename?: 'GuideLevel', id: string } | null } | null }> | null } | null };

export type SkillPathEntryStatusCountsQueryVariables = Types.Exact<{
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.GuideLevelSortInput>> | Types.InputMaybe<Types.GuideLevelSortInput>>;
  openFilter?: Types.InputMaybe<Types.GuideLevelFilterInput>;
  closedFilter?: Types.InputMaybe<Types.GuideLevelFilterInput>;
  scheduledFilter?: Types.InputMaybe<Types.GuideLevelFilterInput>;
}>;


export type SkillPathEntryStatusCountsQuery = { __typename?: 'RootQueryType', open?: { __typename?: 'PageOfGuideLevel', count?: number | null } | null, closed?: { __typename?: 'PageOfGuideLevel', count?: number | null } | null, scheduled?: { __typename?: 'PageOfGuideLevel', count?: number | null } | null };

export const SkillPathEntryFieldsFragmentDoc = gql`
    fragment SkillPathEntryFields on GuideLevel {
  id
  name
  code
  guideId
  subjectId
  onStudentsSkillPaths
  skillPathMinDueDate(status: $status) @skip(if: $isScheduled)
  skillPathMaxDueDate(status: $status) @skip(if: $isScheduled)
  skillPathMinStartDate(status: $status) @include(if: $isScheduled)
  skillPathMaxStartDate(status: $status) @include(if: $isScheduled)
  skillPathStudentCount
  skillPathCompletedStudentCount
  parent {
    id
    parent {
      id
    }
  }
}
    `;
export const SkillPathEntriesDocument = gql`
    query SkillPathEntries($classroomIds: [ID!], $status: SkillPathStatus, $isScheduled: Boolean!, $filter: GuideLevelFilterInput, $sort: [GuideLevelSortInput], $limit: Int, $offset: Int) {
  skillPathEntries(
    classroomIds: $classroomIds
    filter: $filter
    sort: $sort
    limit: $limit
    offset: $offset
  ) {
    hasNextPage
    results {
      ...SkillPathEntryFields
    }
  }
}
    ${SkillPathEntryFieldsFragmentDoc}`;

/**
 * __useSkillPathEntriesQuery__
 *
 * To run a query within a React component, call `useSkillPathEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillPathEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillPathEntriesQuery({
 *   variables: {
 *      classroomIds: // value for 'classroomIds'
 *      status: // value for 'status'
 *      isScheduled: // value for 'isScheduled'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSkillPathEntriesQuery(baseOptions: Apollo.QueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables> & ({ variables: SkillPathEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>(SkillPathEntriesDocument, options);
      }
export function useSkillPathEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>(SkillPathEntriesDocument, options);
        }
// @ts-ignore
export function useSkillPathEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>;
export function useSkillPathEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>): Apollo.UseSuspenseQueryResult<SkillPathEntriesQuery | undefined, SkillPathEntriesQueryVariables>;
export function useSkillPathEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>(SkillPathEntriesDocument, options);
        }
export type SkillPathEntriesQueryHookResult = ReturnType<typeof useSkillPathEntriesQuery>;
export type SkillPathEntriesLazyQueryHookResult = ReturnType<typeof useSkillPathEntriesLazyQuery>;
export type SkillPathEntriesSuspenseQueryHookResult = ReturnType<typeof useSkillPathEntriesSuspenseQuery>;
export type SkillPathEntriesQueryResult = Apollo.QueryResult<SkillPathEntriesQuery, SkillPathEntriesQueryVariables>;
export const SkillPathEntryStatusCountsDocument = gql`
    query SkillPathEntryStatusCounts($classroomIds: [ID!], $sort: [GuideLevelSortInput], $openFilter: GuideLevelFilterInput, $closedFilter: GuideLevelFilterInput, $scheduledFilter: GuideLevelFilterInput) {
  open: skillPathEntries(
    classroomIds: $classroomIds
    filter: $openFilter
    sort: $sort
    limit: 1
  ) {
    count
  }
  closed: skillPathEntries(
    classroomIds: $classroomIds
    filter: $closedFilter
    sort: $sort
    limit: 1
  ) {
    count
  }
  scheduled: skillPathEntries(
    classroomIds: $classroomIds
    filter: $scheduledFilter
    sort: $sort
    limit: 1
  ) {
    count
  }
}
    `;

/**
 * __useSkillPathEntryStatusCountsQuery__
 *
 * To run a query within a React component, call `useSkillPathEntryStatusCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillPathEntryStatusCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillPathEntryStatusCountsQuery({
 *   variables: {
 *      classroomIds: // value for 'classroomIds'
 *      sort: // value for 'sort'
 *      openFilter: // value for 'openFilter'
 *      closedFilter: // value for 'closedFilter'
 *      scheduledFilter: // value for 'scheduledFilter'
 *   },
 * });
 */
export function useSkillPathEntryStatusCountsQuery(baseOptions?: Apollo.QueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>(SkillPathEntryStatusCountsDocument, options);
      }
export function useSkillPathEntryStatusCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>(SkillPathEntryStatusCountsDocument, options);
        }
// @ts-ignore
export function useSkillPathEntryStatusCountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>;
export function useSkillPathEntryStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>): Apollo.UseSuspenseQueryResult<SkillPathEntryStatusCountsQuery | undefined, SkillPathEntryStatusCountsQueryVariables>;
export function useSkillPathEntryStatusCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>(SkillPathEntryStatusCountsDocument, options);
        }
export type SkillPathEntryStatusCountsQueryHookResult = ReturnType<typeof useSkillPathEntryStatusCountsQuery>;
export type SkillPathEntryStatusCountsLazyQueryHookResult = ReturnType<typeof useSkillPathEntryStatusCountsLazyQuery>;
export type SkillPathEntryStatusCountsSuspenseQueryHookResult = ReturnType<typeof useSkillPathEntryStatusCountsSuspenseQuery>;
export type SkillPathEntryStatusCountsQueryResult = Apollo.QueryResult<SkillPathEntryStatusCountsQuery, SkillPathEntryStatusCountsQueryVariables>;